/**
 * Sale display
 * -----------------------------------------------------------------------------
 * Keeps the SALE label beside the product page price in step with the variant
 * the customer has selected.
 *
 * The label is rendered by snippets/sale-price-label.liquid for the variant the
 * page loads with. theme.js then dispatches `variant:change` on document every
 * time the selection changes, carrying the full variant, so the label can be
 * shown, hidden or renumbered from that alone — no fetch, no second source of
 * truth for what is on sale.
 *
 * A label marked data-sale-percent-fixed keeps its number: that number came from
 * the Sale percentage settings, which are deliberately per collection rather
 * than per variant, so recalculating it would throw the client's figure away.
 */
(function () {
  'use strict';

  function percentOff(variant) {
    return Math.round(((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price);
  }

  function update(label, variant) {
    var onSale = !!variant && variant.compare_at_price > variant.price && variant.price > 0;

    label.classList.toggle('hide', !onSale);
    if (!onSale) return;

    if (label.hasAttribute('data-sale-percent-fixed')) return;

    var percent = label.querySelector('[data-sale-percent]');
    if (!percent) return;

    percent.textContent = percentOff(variant) + '% ' + (percent.getAttribute('data-sale-off-text') || '');

    // It starts hidden when the page could not work a figure out: until a
    // variant is chosen the theme prints "From {price_min}" beside the current
    // variant's compare-at, and those two do not describe one discount.
    percent.hidden = false;
  }

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && event.detail.variant;

    document.querySelectorAll('[data-sale-label]').forEach(function (label) {
      update(label, variant);
    });
  });
})();
